import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {AppParametricSelector, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {ApiTokenModel} from '../../../../models/api/apiTokenModel';
import {AppState} from '../../../../store/appState';
import {getApiTokenScopes, makeGetApiToken} from '../../../../store/data/apiTokens/apiTokensSelectors';
import {getTeammates} from '../../../../store/data/teammates/teammatesSelectors';
import {DevelopersApiTokensTableRow} from './developersApiTokensTableRow';

/*
 * Props.
 */

interface DevelopersApiTokensTableRowContainerProps {
  tokenId: number;
}

/*
 * Selectors.
 */

function getTokenId(_state: AppState, props: DevelopersApiTokensTableRowContainerProps) {
  return props.tokenId;
}

function makeGetOwner(getToken: AppParametricSelector<any, ApiTokenModel | undefined>) {
  return createSelector([getToken, getTeammates], (token, teammates) => {
    if (!token || !token.ownerId) {
      return undefined;
    }
    return teammates[token.ownerId];
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DevelopersApiTokensTableRowContainerProps>()(() => {
  const getToken = makeGetApiToken(getTokenId);
  return {
    token: getToken,
    owner: makeGetOwner(getToken),
    scopes: getApiTokenScopes,
  };
});

export const DevelopersApiTokensTableRowContainer = connect(mapStateToProps)(DevelopersApiTokensTableRow);
